import PageName from "../../components/PageName";
import Card from "../../components/Base/Card";
import {FiChevronDown, FiPlus} from "react-icons/fi";
import BaseFilter from "../../components/Base/BaseFilter";
import BaseDateRangePicker from "../../components/Base/BaseDateRangePicker";
import {Table} from "../../components/Base/BaseTable";
import NoTransactionImage from "../../assets/images/no-transactions.png";
import React, {useMemo, useState} from "react";
import {HiDotsVertical} from "react-icons/hi";
import InviteFriendModal from "../../components/InviteFriendModal";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const MyReferrals = () => {
    const [filterValue, setFilterValue] = useState('');
    const [startDate, setStartDate] = useState<Date>()
    const [endDate, setEndDate] = useState<Date>()
    const [showInviteModal, setShowInviteModal] = useState(false);

    const toggleShowInviteModal = ()=>setShowInviteModal(!showInviteModal)

    const setDateRangeHandler = (dates: Date[]) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const columns = useMemo(()=>[
        {
            Header: '#',
            accessor: 'id'
        },
        {
            Header: 'Referred Friend\'s Name',
            accessor: 'referralName'
        },
        {
            Header: 'Email Address',
            accessor: 'email'
        },
        {
            Header: 'Phone Number',
            accessor: 'phoneNumber'
        },
        {
            Header: 'Status',
            accessor: 'isActive',
            // @ts-ignore
            Cell: ({ cell: { value }})=>(
                <div className={`py-1 w-[100px] text-center rounded-full ${value ? 'bg-successBG text-primary' : 'text-danger bg-bangerBG'}`}>
                    {value ? 'Active' : 'Not Active'}
                </div>
            )
        },
        {
            Header: 'Action',
            accessor: '',
            // @ts-ignore
            Cell: ({row: { values }})=>{
                return (
                    <button className="btn btn-text" onClick={()=>{}}>
                        <HiDotsVertical />
                    </button>
                )
            }
        }
    ], [])


    return (

        <TimeOutActivityLayout>
        <div className="transaction-page">
            <InviteFriendModal
                showModal={showInviteModal}
                onClose={toggleShowInviteModal}
            />
            <PageName pageName={"My Referrals"} />
            <div className="transaction">

                <Card className="transaction-card">
                    <div className="h1 text-grayscaleBody border-b pb-4">
                        Referrals
                    </div>
                    <div className="flex justify-end mt-10">
                        <button className="btn btn-primary btn-b" onClick={toggleShowInviteModal}>
                            <FiPlus className="text-xl mr-4" />
                            Invite more friends
                        </button>
                    </div>
                    {/*
                    <div className="table-filter-group">
                        <div className="table-filter">
                            <BaseFilter
                                value={filterValue}
                                onChange={val=>setFilterValue(val)}
                            />
                            <BaseDateRangePicker
                                className="mt-4 sm:mt-0 max-w-full  sm:max-w-[328px] sm:ml-4"
                                onChange={(date)=>setDateRangeHandler(date)}
                            />
                            {/*
                            <div>
                                <button className="btn btn-outline btn-b">
                                    Search
                                </button>
                            </div>
                            */}{/*
                        </div>
                        <div className="table-sort">
                            <button className="btn btn-outline btn-b">
                                Sort
                                <FiChevronDown className="ml-2 " />
                            </button>
                        </div>
                    </div>
                    <div className="mt-10">
                        {/*@ts-ignore*/}{/*
                        <Table filterValue={filterValue} columns={columns} data={tableData} />
                    </div>
*/}
                </Card>
            </div>

        </div>
        </TimeOutActivityLayout>
    )
}
export default MyReferrals;